module.exports = __webpack_public_path__ + "static/fipcrosebunny4-14ceadb80bd0c7d56244824f27379810.jpeg";